import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from '../core.state';
import { RouterStateUrl } from './router.state';

export const selectRouterState = createFeatureSelector<AppState, RouterReducerState<RouterStateUrl>>(
    'router'
);

export const getRouterInfo = createSelector(
    selectRouterState,
    state => state?.state
);
